export const environment = {
  production: true,
  //serverUrl: 'http://localhost:3000/',
  //  serverUrl: 'https://gsfapi.educian.com/'
  serverUrl: 'https://gsfprodapi.educian.com/',
  //  serverUrl:'https://gsfapidev.educian.com/',
  //serverUrl: 'https://gsftestapi.educian.com/',
  forgetPasswordReturnUrl: 'reset-password'
}
